import { connect } from 'react-redux';
import { LtvCalculatorComponent } from './../../components/LtvCalculator/LtvCalculatorComponent';

const mapStateToProps = state => (state);
const mapDispatchToProps = dispatch => ({
  onChangeInput: (field, value) => {
    dispatch({ type: 'UPDATE_INPUT', payload: { field, value } });
  },
  onChangePlan: (value) => {
    dispatch({ type: 'UPDATE_PLAN', payload: value });
    dispatch({ type: 'SCREEN_RESIZE' });
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(LtvCalculatorComponent);



// WEBPACK FOOTER //
// ./src/containers/LtvCalculator/LtvCalculator.js